import useOAuth2 from "../OAuth2/OAuth2";
import React, {useEffect, useState} from "react";
import Container from '@mui/material/Container';
import {ThemeDirection, ThemeMode} from "../config";
import {Box, CardMedia} from "@mui/material";
import HeaderPage from "../sections/landing/Header";
import HomeHeaderPage from "../sections/home/Header";
import {useTheme} from "@mui/material/styles";
const dashImage = require.context('../assets/landing', true);


const Home = (props) => {
    const access_token = props.access_token
    const exp_time = props.exp_time
    const refresh_token = props.refresh_token
    const tenantId = props.tenantId

    const theme = useTheme();
    const [visible, setVisible] = useState(false);


    useEffect(() => {
        console.log(props);
        console.log(access_token);
        console.log(exp_time);
        console.log(refresh_token);
        console.log(tenantId);


        const listenToScroll = () => {
          let heightToHideFrom = 250;
          const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

          if (winScroll > heightToHideFrom) {
            setVisible(true);
          } else {
            visible && setVisible(false);
          }
        };

        window.addEventListener('scroll', listenToScroll);
        return () => window.removeEventListener('scroll', listenToScroll);
    }, [visible]);

    return (
      <>
          <Box
        sx={{
          position: 'relative',
          bgcolor: theme.palette.mode === ThemeMode.DARK ? 'grey.0' : 'grey.800',
          overflow: 'hidden',
          minHeight: '100vh',
          '&>*': {
            position: 'relative',
            zIndex: 5
          },
          '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: 2,
            background:
              theme.direction === ThemeDirection.RTL
                ? {
                    xs: 'linear-gradient(-360.36deg, rgb(0, 0, 0) 14.79%, rgba(67, 67, 67, 0.28) 64.86%)',
                    md: 'linear-gradient(-329.36deg, rgb(0, 0, 0) 1.79%, rgba(67, 67, 67, 0.28) 64.86%)',
                    xl: 'linear-gradient(-329.36deg, rgb(0, 0, 0) 1.79%, rgba(67, 67, 67, 0.28) 64.86%)'
                  }
                : 'linear-gradient(329.36deg, rgb(0, 0, 0) 14.79%, rgba(67, 67, 67, 0.28) 64.86%)'
          }
        }}
      >
        <CardMedia
          component="img"
          image={dashImage(`./landingpage-theme1.jpg`)}
          sx={{
            position: 'absolute',
            width: { md: '78%', lg: '70%', xl: '65%' },
            right: { md: '-14%', lg: '-4%', xl: '-2%' },
            top: { md: '16%', lg: '12%', xl: '8%' },
            zIndex: 1,
            display: { xs: 'none', md: 'block' }
          }}
        />
                <HomeHeaderPage />
      </Box>

      </>
  );

};

export default Home;